import React, { useRef } from 'react';

import { SelfSharingControlsLayerRendererProps } from '@yandex-video-platform/goloom-sdk-react';
import { useSelector } from 'react-redux';

import { SELF } from '../../../../../shared/constants';
import { useTypedSelector } from '../../../../../shared/hooks/useTypedSelector';
import { useVideoOrientation } from '../../../../../shared/hooks/useVideoOrientation';
import { ParticipantStatuses } from '../../../components/participant-statuses';
import { NetworkQualityType } from '../../../constants';
import { getParticipant, selectNetworkQualityType } from '../../../selectors';
import styles from './styles.css';

export const SelfSharingControlsLayer: React.FC<SelfSharingControlsLayerRendererProps> = ({ videoElementRef }) => {
    const networkQuality = useSelector(selectNetworkQualityType);
    const layerRef = useRef<HTMLDivElement>(null);

    const self = useTypedSelector((state) => getParticipant(state, SELF));

    useVideoOrientation(videoElementRef.current);

    return (
        <div ref={layerRef} className={styles.selfSharingControlsLayer}>
            <ParticipantStatuses
                participant={self}
                isBadNetworkQuality={networkQuality === NetworkQualityType.BAD}
                isMainSlot={true}
            />
        </div>
    );
};
